module.exports = __webpack_public_path__ + "static/LibreFranklin-Bold-f5ae33e0fc0c3d498f3ad1c620a7800c.ttf";